export default class OptionRequirement {
  public requiredQuestion: string;

  public requiredOption: number;

  constructor(requiredQuestion: string, requiredOption: number) {
    this.requiredQuestion = requiredQuestion;
    this.requiredOption = requiredOption;
  }
}
